import { i18n } from 'plugins/i18n.js'
import moment from 'moment'

export default {
  data() {
    return {
      mixinStatusColorGroup: {
        registration: [1, 'Реєстрація', 'additionalAgreement','1.1', 'NOT_ACTIVE'],
        waiting: [3, 'IMPROVE', false, 'Waiting', 'WAITING', 'A', 'NOT_VERIFIED', 'PENDING', 'Аналіз пропозицій', 'PARTIAL'],
        acceptanceOffers: [4, 'Прийом пропозицій'],
        prequalification: [5, 'Прекваліфікація'],
        auction: [7, 'R', 'Аукціон'],
        qualification: [8, 'D', 'Кваліфікація', 'MANUALLY_ADDED', 'REWORKING'],
        proposalsConsidered: [9, 'Пропозиції розглянуті'],
        success: [10, 'NEW_FEATURE', 'ACTIVE' ,true, 'Success', 'SUCCESS', 'Cancel', 'W', 'VERIFIED', 'RECOMENDED', 'Завершено',
          'Recomended', 'AI_GENERATED', 'ALL', 'PUBLISHED', 'ACCREDITED', 'OK'],
        purchaseNotPlace: [11, 'Закупівля не відбулась', 'EDITED'],
        decline: [12, '1.2', 'ARCHIVE', 'Decline' ,'DECLINE' ,'CANCELED', 'C', 'Execution', 'EXPIRED', 'UNSUCCESSFULL',
          'NOT_RECOMENDED', 'Закупівля відмінена', 'NotRecomended', 'NONE', 'DECLINED', 'FAIL', 'FAILED'],
        queued: ['Queued', 'QUEUED'],
        canceled: ['Canceled'],
        draft: ['F', 'Draft', 'DRAFT'],
        bugFix: ['BUG_FIX'],
      }
    }
  },
  filters: {
    formSum(val) {
      if (!val) { return '–' }
      if (val + '' && parseFloat(val)) {
        val = (+val)?.toFixed(2) || 0
        return Intl.NumberFormat('ru-RU').format(val)
        // return (+(parseFloat(val)).toFixed(2) + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
      }
      return val
    },
    formatDate(value) {
      if (value && moment(value).isValid()) {
        return `${i18n.d(new Date(value), 'shortDate')}, ${i18n.d(new Date(value), 'time')}`
      } else {
        return '–'
      }
    },
  },
  methods: {
    formatBy(value, format = 'DD.MM.YYYY, HH:mm') {
      try {
        if (value) {
          if (format === 'DD.MM.YYYY, HH:mm') {
            return `${i18n.d(new Date(value), 'shortDate')}, ${i18n.d(new Date(value), 'time')}`
          } else if (format === 'DD.MM.YYYY') {
            return i18n.d(new Date(value), 'shortDate')
          }
          return moment(value).format(format)
        } else {
          return '–'
        }
      } catch (_) {
        return '–'
      }
    },
    formSum(val, catch_zero, toFixed = 2) {
      if (!val) { return catch_zero ? '–' : 0 }
      if (val + '' && parseFloat(val)) {
        val = (+val)?.toFixed(toFixed) || 0
        return Intl.NumberFormat('ru-RU').format(val)
        // return (+(parseFloat(val)).toFixed(2) + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
      }
      return val
    },
    formatNumber(value) {
      return value?.toLocaleString(sessionStorage.language)
    },
    formatDate(value) {
      if (value && moment(value).isValid()) {
        return i18n.d(new Date(value), 'longMonth')
      } else {
        return ''
      }
    },
    formatDateTo(value) {
      return value ? `${this.$t('Common.DateTo')} ${i18n.d(new Date(value), 'longMonth')}, ${i18n.d(new Date(value), 'time')}` : ''
    },
    getColor(status, object, keyName) {
      if (!status) {
        return {
          background: 'var(--status-none)',
          color: 'white'
        }
      }
      let background = 'blue'
      let color = 'white'
      let statusId = status
      if (object) {
        statusId = status[keyName]
      }

      if (this.mixinStatusColorGroup.registration.includes(statusId)) {
        color = 'black'
        background = 'var(--status-registration)'
      } else if (this.mixinStatusColorGroup.waiting.includes(statusId)) {
        color = 'black'
        background = 'var(--status-waiting)'
      } else if (this.mixinStatusColorGroup.acceptanceOffers.includes(statusId)) {
        color = 'black'
        background = 'var(--status-acceptance-offers)'
      } else if (this.mixinStatusColorGroup.prequalification.includes(statusId)) {
        color = 'black'
        background = 'var(--status-prequalification)'
      } else if (this.mixinStatusColorGroup.auction.includes(statusId)) {
        color = 'black'
        background = 'var(--status-auction)'
      } else if (this.mixinStatusColorGroup.qualification.includes(statusId)) {
        color = 'white'
        background = 'var(--status-qualification)'
      } else if (this.mixinStatusColorGroup.proposalsConsidered.includes(statusId)) {
        color = 'black'
        background = 'var(--status-proposals-considered)'
      } else if (this.mixinStatusColorGroup.success.includes(statusId)) {
        color = 'black'
        background = 'var(--status-success)'
      } else if (this.mixinStatusColorGroup.purchaseNotPlace.includes(statusId)) {
        color = 'black'
        background = 'var(--status-purchase-not-place)'
      } else if (this.mixinStatusColorGroup.decline.includes(statusId)) {
        color = 'black'
        background = 'var(--status-decline)'
      } else if (this.mixinStatusColorGroup.queued.includes(statusId)) {
        color = 'black'
        background = 'var(--status-queued)'
      } else if (this.mixinStatusColorGroup.canceled.includes(statusId)) {
        color = 'white'
        background = 'var(--status-canceled)'
      } else if (this.mixinStatusColorGroup.draft.includes(statusId)) {
        background = 'var(--status-draft)'
        color = 'white'
      } else if (this.mixinStatusColorGroup.bugFix.includes(statusId)) {
        background = 'var(--status-bug-fix)'
        color = 'white'
      } else {
        background = 'var(--status-default)'
        color = 'white'
      }

      return {
        background,
        color: color
      }
    },
    bigFirstLetter(element) {
      return (element[0]?.toUpperCase() || '') + element?.slice(1)?.toLowerCase() || ''
    },
    smallFirstLetter(element) {
      return (element?.[0]?.toLowerCase() || '') + element?.slice(1) || ''
    },
    commentRule(el, boolean) {
      let text = el.trim(),
        words_length = text.split(' ').length,
        result = !el && this.$t('Validate.Required') || (text.length <= 10 || words_length < 2) && this.$t('Common.Required10')
      return boolean ? typeof result != 'string' : (result || true)
    },
    normalizeNum(text) {
      return (+ (('' + text).replace(/,/,'.')).replace(/\s/g, ''))
    },
    $_formatValue(val) {
      return parseFloat(('' + val).replace(/,/,'.')) || 0
    },
    sliceText(value, ref, slice_num , set_value_func = () => {}, cut_main) {
      if (!value) {
        return true
      }
      let setLazyValue = () => {
        if (ref?.lazyValue) {
          ref.lazyValue = value
          // ref.value = value
        }
      }
      value = value + ''
      value = value.replace(/[^,.\d]/g, '')

      // let check = (str) => value.includes(str) && value.indexOf(str) != (value.length - 1),
      let val
      let sliceBy = (type) => {
        val = value.split(type)
        val[0] = val[0].slice(0, cut_main || 16)
        if ( val[1]) {
          val[1] = val[1].slice(0, slice_num)
        }
        if (val.length > 2) {
          val = val.slice(0, 2)
        }
        value = slice_num ? val.join(type) : val[0]
      }
      if (value.includes('.')) {
        sliceBy('.')
        if (value.includes(',')) {
          value = value.replace(/[^.\d]/g, '')
        }
      } else if (value.includes(',')) {
        sliceBy(',')
        if (value.includes(',')) {
          value = value.replace(/[^,\d]/g, '')
        }
      } else if (value.length > (cut_main || 16)) {
        value = value.slice(0, cut_main || 16)
      }

      setLazyValue()
      set_value_func(value)

      return true
    },
    $_getShortName(item) {
      return item?.split(' ').map(el => el.length > 5 ? el[0] + '.' : el).join('')
    },
    getCurrency(item, currencies) {
      if (!item) {
        return ''
      }
      currencies ||= this.currencies
      let curr = currencies?.find(el => el.code == item.currencyId)
      return curr?.shortTitle || this.$_getShortName(curr?.title) || curr?.title || this.tender.currency?.title || '–'
    },
    $_checkMenuHright(ref) {
      setTimeout(() => {
        if (!ref) {
          return
        }
        const window_relative_height = document.documentElement.getBoundingClientRect().height,
          menu_params = ref.getBoundingClientRect(),
          window_height_w_menu = menu_params.height + menu_params.top,
          height_diff = window_relative_height - window_height_w_menu
        if (height_diff < 0) {
          ref.parentNode.style.top = parseInt(ref.parentNode.style.top) + height_diff - 30 + 'px'
        }
      }, 100)
    }
  }
}
